import React from 'react';

const Chip = ({ label, value, accent }) => (
  <span className="whitespace-nowrap">
    <span className="text-ink-mute mono uppercase tracking-widest text-[11px] mr-2">{label}</span>
    <span className={accent ? 'text-brand font-medium' : 'text-foreground/90'}>{value}</span>
  </span>
);

const MetaBar = () => (
  <section className="border-y border-border/60 mt-16">
    <div className="max-w-6xl mx-auto px-6 py-6 grid gap-3 md:grid-cols-3 text-[12.5px]">
      <Chip label="Last role at" value="JPMorgan Chase · Vice President" />
      <Chip label="Ex" value="Deutsche Bank · UBS · RBS · Infosys" />
      <Chip label="Based in" value="Hyderabad, India" />
      <Chip label="Focus" value="SRE · Platform Eng. · Cloud · AI" />
      <Chip label="Education" value="IIM Ahmedabad SMP · B.E. CSE" />
      <Chip label="Open to" value="Available immediately · Advisory · Speaking" accent />
    </div>
  </section>
);

export default MetaBar;
